import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { CrossIconWhite } from "../../assets";
import { EMPTY_STRING } from "../../constants";

const ExpandedSlider = ({ images }) => {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      loop={true}
      pagination={{
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      }}
      navigation={true}
      modules={[Pagination, Navigation]}
      className="mySwiper"
    >
      {images.map((image, index) => (
        <SwiperSlide className="h-100">
          <div className="m-auto slider-image-container">
            <img src={image.url} alt={EMPTY_STRING} className="slider-image" />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ExpandedSlider;
